class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
      this.notifyNativeInputListeners();
    }
  }

  // Dispatches real input/change events so external listeners (e.g. Nosto's
  // own autocomplete script) see programmatic value changes, since scripted
  // `.value = ''` writes don't fire those natively.
  notifyNativeInputListeners() {
    if (!this.input) return;
    this.input.dispatchEvent(new Event('input', { bubbles: true }));
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // Nosto only wraps this widget when the "Enable predictive search for
  // Nosto" section setting is on; check live rather than caching, since the
  // wrapper is injected/rendered independently of this element's lifecycle.
  isInsideNostoWrapper() {
    return !!this.input?.closest('.nosto-autocomplete-wrapper');
  }
}

customElements.define('search-form', SearchForm);
